// extracted by mini-css-extract-plugin
export default {"invitations":"styles_invitations__AhmRH","invitations__tabs":"styles_invitations__tabs__Ser5Z","invitations__main":"styles_invitations__main__ISQ6k"};